import React, { useState } from 'react'
import Trash from '../icons/Trash'
import Modal from './Modal'
import RemoveLessonPlanModal from './RemoveLessonPlanModal'

type Props = {
  lessonPlanId: number
  unitId: number
}

const RemoveLessonPlanButton = ({ lessonPlanId, unitId }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleModal = () => {
    setIsOpen(!isOpen)
  }

  return (
    <>
      <div
        onClick={toggleModal}
        className="bg-darkRed px-4 py-2 rounded-md flex items-center gap-1 cursor-pointer mt-2 z-10">
        <div className="text-white w-5 h-5">
          <Trash />
        </div>
        <div className="text-14 font-semibold text-white">Delete</div>
      </div>
      <Modal isOpen={isOpen} toggleModal={toggleModal}>
        <RemoveLessonPlanModal unitId={unitId} onClose={toggleModal} lessonPlanId={lessonPlanId} />
      </Modal>
    </>
  )
}

export default RemoveLessonPlanButton
